import React from "react";

export default function Renewable() {
    return (<div style={{color:"#fff"}}>Renewable</div>);
}